import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../../../core/services/notification.service';

interface OrderToast {
  id: number;
  order: any;
  visible: boolean;
  time: string;
}

@Component({
  selector: 'app-order-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './order-notification.html',
  styleUrls: ['./order-notification.css'],
})
export class OrderNotificationComponent implements OnInit, OnDestroy {
  toasts: OrderToast[] = [];
  private sub!: Subscription;
  private counter = 0;

  constructor(
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.sub = this.notificationService.newOrder$.subscribe((order) => {
      const now = new Date();
      const timeStr = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

      const toast: OrderToast = {
        id: ++this.counter,
        order,
        visible: true,
        time: timeStr,
      };

      this.toasts.unshift(toast);
      this.cdr.detectChanges();

      setTimeout(() => {
        this.dismissToast(toast.id);
      }, 6000);
    });
  }

  dismissToast(id: number): void {
    const toast = this.toasts.find((t) => t.id === id);
    if (toast && toast.visible) {
      toast.visible = false;
      this.cdr.detectChanges();
      setTimeout(() => {
        this.toasts = this.toasts.filter((t) => t.id !== id);
        this.cdr.detectChanges();
      }, 450);
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
